function checkVariantQuickView(event) {
  let combinedHandles = Array.from(document.querySelectorAll("quick-view variant-radios fieldset input:checked+.label-swatch"))
  .map(swatch => swatch.getAttribute("title-handle"))
  .filter(handle => handle)
  .join('-');

  let count = 0;
  document.querySelectorAll("quick-view .product__gallery .product__media.card.media").forEach(function(cardMedia) {
    var altText = cardMedia.getAttribute("alt-text");
    if (altText.includes(combinedHandles) || altText.includes("-all")) {
      cardMedia.style.cssText = "display: block;";
      count++;
    } else {
      cardMedia.style.cssText = "display: none;";
    }
  });

  document.querySelectorAll("quick-view media-dots button").forEach(function(dot, index) {
    if ( index <= count ){
      dot.style.cssText = "display: flex;";
    }else{
      dot.style.cssText = "display: none;";
    }
  });
}

document.addEventListener('quickview:loaded', function(evt) {
  checkVariantQuickView();
  
  var labelSwatches = document.querySelectorAll(".quick-view__content .label-swatch");
  for (var i = 0; i < labelSwatches.length; i++) {
    labelSwatches[i].addEventListener('click', function(event) {
      setTimeout(function () {
        checkVariantQuickView();
      }, 0);
    });
  }
});